import { render, staticRenderFns } from "./FrameAssemblyCreateForm.vue?vue&type=template&id=2fec8716&scoped=true"
import script from "./FrameAssemblyCreateForm.vue?vue&type=script&lang=ts"
export * from "./FrameAssemblyCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec8716",
  null
  
)

export default component.exports